let data101;
if (typeof window === "undefined") {
  data101 = require("../static-s101/Data.json");
} else {
  // data101 = require("../static-s101/Data.json");
  // window.data101 = data101;
  data101 = window.data101;
}

export { data101 };
